<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">訂單管理 / 餐期查詢</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px" visible>
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">品牌：</label>
                  <div class="col-md-4">
                    <select
                      name="queryBrandsCode"
                      class="form-control"
                      v-model="queryBrandsCode"
                    >
                    <option
                      v-for="x in selectListBrands"
                      v-bind:value="x.Code"
                      :key="x.Code"
                    >{{x.Text}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">取餐日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                  <label class="mt-2">(日期區間可篩選31日)</label>
                </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">門市：</label>
                <div class="col-md-4">
                  <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" selectLabel="">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                  <!-- <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" selectLabel="">
                    <span slot="noResult">查無資料</span>
                  </multiselect> -->
                </div>
                <label class="control-label col-md-2 mt-2 text-right">餐期</label>
                <div class="col-md-4">
                  <select id="period" name="payment" class="form-control" v-model="periodID">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in periodList" v-bind:value="x.ID" :key="x.ID">{{x.Desc}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right"></label>
                <div class="col-md-3">
                </div>
                <div class="col-lg-6 mt-2 text-right">
                    <button type="button" class="btn btn-warning text-white" @click="querySearch()">查詢</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="table-responsive col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <!-- <th style="text-align: center;">門市</th> -->
                  <th>序號</th>
                  <th>門市</th>
                  <th>取餐日 / 餐期</th>
                  <th style="text-align: right;">訂單數量</th>
                  <th style="text-align: right;">訂單總額</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, index) in respList" :key="x.code+x.takeDate+x.periodDesc">
                  <!-- <td style="text-align: left;">{{x.PaymentType}}</td> -->
                  <td>{{((toPage-1)*pageRows+index+1)}}</td>
                  <td>{{x.code}} <br/> {{x.name}}</td>
                  <td>{{x.takeDate}} <br/> {{x.periodDesc}}</td>
                  <td style="text-align: right;">{{x.qty | numberToCurrencyNo}}</td>
                  <td style="text-align: right;">{{x.amount | numberToCurrencyNo}}</td>
                  <!-- <td>{{x.RefundSum | formatThousand}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row" style="padding: 0 1rem">
            <b-pagination size="md" :total-rows="totalRows" v-model="toPage" :per-page="pageRows" @change="changePage"></b-pagination>
            <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      storelist: [{ ID: 0, Code: '', Name: '' }],
      periodList: [], // 餐期
      sdate: '',
      edate: '',
      store: '', // 門市
      periodID: 0,
      respList: [],
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      toPage: 0,
      queryBrandsCode: "MWD",
      selectListBrands: [], // 品牌下拉選單
    }
  },
  created () {
    this.setdate()
    this.getpost()
    this.queryPeriodList()
    this.querySelectListBrands()
    this.FunctionPermission = getFunctionPermission('F35') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    querySearch () {
      this.toPage = 1
      this.getinformation()
    },
    getinformation () {
      if (!this.store) {
        this.store = ''
      }
      if (this.sdate === '' || this.edate === '') {
        miniToastr.error('請輸入訂餐日期')
        return
      }
      if (this.sdate > this.edate) {
        miniToastr.error('請選擇正確的日期區間')
        return
      }
      // 計算天數
      var d1 = Date.parse(new Date(this.sdate))
      var d2 = Date.parse(new Date(this.edate))
      var day = parseInt((d2 - d1) / (1000 * 60 * 60 * 24))
      if (day > 30) {
        miniToastr.error('日期區間超過31日')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ordermanage/mealPeriod/list', {
        dateStart: this.sdate,
        dateEnd: this.edate,
        storeCode: this.store.Code,
        mealID: Number(this.periodID),
        toPage: this.toPage,
        perPage: this.pageRows,
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.totalRows = (response.data.data.rows === undefined) ? 0 : response.data.data.rows
            this.respList = response.data.data.list
            this.startRowNum = (response.data.data.rows === undefined || response.data.data.rows === 0) ? 0 : this.pageRows * (this.toPage - 1) + 1
            this.endRowNum = (response.data.data.rows === undefined || response.data.data.rows === 0) ? 0 : (this.pageRows > response.data.data.rows) ? response.data.data.rows : (this.toPage * this.pageRows) >= response.data.data.rows ? response.data.data.rows : this.toPage * this.pageRows
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var today = new Date()
      var todaymon = today.getMonth() + 1
      if (todaymon < 10) {
        todaymon = '0' + todaymon
      }

      var date = new Date()
      date.setMonth(date.getMonth())
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + todaymon + '-' + day
      this.edate = year + '-' + todaymon + '-' + day
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          if (response.data.result === '0000') {
            var plist = []
            var list = response.data.data
            list.forEach(function (arrRole, Index) {
              arrRole.Districts.forEach(function (arrRole1, Index1) {
                if (arrRole1.District === '全部區域') {
                  if (arrRole1.Stores) {
                    arrRole1.Stores.forEach(function (arrRole2, Index2) {
                      plist.push(arrRole2)
                    })
                  }
                }
              })
            })
            this.storelist = plist
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    queryPeriodList () {
      // 餐期
      axios
        .post(API_URL + '/web/ordermanage/period/v1', {
          status: 0
        })
        .then(response => {
          this.periodList = response.data.data
          this.$parent.Loading = false
        })
        .catch(error => {
          this.periodList = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
        })
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    changePage (currentPage) {
      this.toPage = currentPage
      this.getinformation()
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    }
  },
  watch: {
    queryBrandsCode(selectedBrandCode) {
      if (selectedBrandCode) {
      this.getpost()
      }
    }
  },
  filters: {
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon =
        d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min
    },
    formatThousand: function (value) {
      return value
        .toString()
        .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
          return pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
        })
    },
    numberToCurrencyNo: function (value) {
      if (!value) return 0
      // 获取整数部分
      const intPart = Math.trunc(value)
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      // 预定义小数部分
      let floatPart = ''
      // 将数值截取为小数部分和整数部分
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) { // 有小数部分
        floatPart = valueArray[1].toString() // 取得小数部分
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    }
  }
}
</script>
<style scoped>
  fieldset {
    padding: 8px 22px 18px;
    margin: 3px 12px 18px;
    border: 1px solid #519b39;
  }
  legend {
    padding: .2em;
    border: 0;
    width: auto;
    color: #519b39;
  }
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
  .font_text {
    font-size: 19px;
    margin: 6px 0 7px;
  }
  .icon_img {
    height: 100%;
    padding: 0;
    margin: -2px;
  }
  /* #mytable > tbody > tr > td {
    vertical-align: middle;
    text-align: right;
    height: 59px;
  }
  #mytable > tbody > tr > th {
    text-align: center;
    height: 59px;
  } */

</style>



// WEBPACK FOOTER //
// src/pages/order/period/List.vue